import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Dropdown, Form, Icon, Popup } from "semantic-ui-react";
import { getLookBackWindow, getReportingPeriods } from "../../../../libs/common_utils";

export const DateWindowField = ({ values, updateValues, dateWindowType, tooltipMessage }) => {
  const intl = useIntl();

  const getDateWindows = () => {
    switch (dateWindowType) {
      case "reporting_period":
        return getReportingPeriods(intl);
      case "lookback_window":
        return getLookBackWindow(intl);
    }
  };

  const labelMap = {
    // biome-ignore lint/style/useNamingConvention: <based off of server prop>
    reporting_period: {
      id: "LABEL_REPORTING_PERIOD",
      defaultMessage: "Date Window",
    },
    // biome-ignore lint/style/useNamingConvention: <based off of server prop>
    lookback_window: {
      id: "LABEL_LOOKBACK_WINDOW",
      defaultMessage: "Lookback Window",
    },
  };

  return (
    <Form.Field className="filter-field">
      <label>
        {intl.formatMessage({
          id: labelMap[dateWindowType].id,
          defaultMessage: labelMap[dateWindowType].defaultMessage,
        })}
        {tooltipMessage && (
          <Popup
            inverted
            style={{ marginLeft: "0.5em" }}
            content={
              <div>
                {tooltipMessage.split("\n").map((line) => (
                  <div key={line}>{line}</div>
                ))}
              </div>
            }
            size="mini"
            trigger={
              <Icon
                name="help circle"
                style={{ position: "relative" }}
                className="cursor-help"
              />
            }
          />
        )}
      </label>
      <Dropdown
        data-id="reporting_period"
        data-testid="report-reporting-period-dropdown"
        selection
        options={getDateWindows()}
        name={dateWindowType}
        value={values[dateWindowType]}
        selectOnNavigation={false}
        onChange={(_e, data) => {
          updateValues({
            [dateWindowType]: data.value,
          });
        }}
      />
    </Form.Field>
  );
};
DateWindowField.propTypes = {
  values: PropTypes.object.isRequired,
  updateValues: PropTypes.func.isRequired,
  dateWindowType: PropTypes.oneOf(["reporting_period", "lookback_window"]).isRequired,
  tooltipMessage: PropTypes.string,
};
